import React from "react";
import "../styles/AddressAutocomplete.css";
import { useState } from "react";

export default function AddressAutocomplete({
  value,
  onChange,
  onSelect,
  placeholder,
}) {
  // ⚠️ TESTING ONLY — replace with an env var before shipping
  const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);

    if (inputValue.length < 3) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        "https://places.googleapis.com/v1/places:autocomplete",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Goog-Api-Key": API_KEY, // <-- use header, not query param
            // ask only for fields we use (saves quota)
            "X-Goog-FieldMask":
              "suggestions.placePrediction.placeId,suggestions.placePrediction.text",
          },
          body: JSON.stringify({
            input: inputValue,
            // Optional: bias or restrict
            // locationBias: { rectangle: { low: { latitude: 24.5, longitude: -125 }, high: { latitude: 49.5, longitude: -66 } } }, // US bounding box
            // includedRegionCodes: ["us"], // or ["ng"], etc.
          }),
        }
      );

      if (!res.ok) {
        console.error("Autocomplete HTTP error", res.status, await res.text());
        setSuggestions([]);
      } else {
        const data = await res.json();
        const items =
          data.suggestions?.map((s) => ({
            id: s.placePrediction.placeId,
            description: s.placePrediction.text?.text ?? "",
          })) || [];
        setSuggestions(items);
      }
    } catch (error) {
      console.error("Autocomplete fetch error:", error);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async (suggestion) => {
    onChange(suggestion.description);
    setSuggestions([]);

    try {
      const res = await fetch(
        `https://places.googleapis.com/v1/places/${suggestion.id}`,
        {
          headers: {
            "X-Goog-Api-Key": API_KEY,
            "X-Goog-FieldMask":
              "id,displayName,formattedAddress,addressComponents,location",
          },
        }
      );

      if (!res.ok) {
        console.error("Place details HTTP error", res.status, await res.text());
        return;
      }

      const placeData = await res.json();
      onSelect(placeData);
    } catch (error) {
      console.error("Place details fetch error:", error);
    }
  };

  return (
    <div className="address-autocomplete">
      <input
        type="text"
        placeholder={placeholder || "Start typing your address..."}
        value={value}
        onChange={handleInputChange}
        autoComplete="off"
      />
      {loading && <div style={{ padding: "8px" }}>Loading...</div>}
      {suggestions.length > 0 && (
        <ul className="address-suggestions">
          {suggestions.map((s) => (
            <li key={s.id} onClick={() => handleSelect(s)}>
              {s.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
